import React, { useMemo, useState } from 'react'

import { LumiContextControllerProps } from './LumiContextController.types'
import { FileWithPath, Stage } from './LumiContext.types'
import { LumiContext } from './LumiContext'

export const LumiContextController = ({ children }: LumiContextControllerProps) => {
    const [acceptedFiles, setAcceptedFiles] = useState<readonly FileWithPath[]>([])
    const [stage, setStage] = useState(Stage.Init)

    const handleChangeAcceptedFiles = (acceptedFiles: readonly FileWithPath[]) => {
        setAcceptedFiles(acceptedFiles)
    }

    const handleChangeStage = (stage: Stage) => {
        setStage(stage)
    }

    const contextValue = useMemo(
        () => ({
            acceptedFiles,
            onChangeAcceptedFiles: handleChangeAcceptedFiles,
            stage,
            onChangeStage: handleChangeStage,
        }),
        [acceptedFiles, stage],
    )

    return <LumiContext.Provider value={contextValue}>{children}</LumiContext.Provider>
}
